import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'Zeller currently operates in Australia',
  description:
    'We greatly value your interest and would love to keep you informed about any future expansion. We encourage you to {link} so you will be among the first to be notified when we roll out in your area.',
  linkWaitListLabel: 'join our waitlist',
  primaryButtonLabel: 'Back to Log in',
})
